var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"headerWrapper",staticClass:"section-header pageHeader"},[_c('h1',[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"section-header-breadcrumb"},[_vm._t("buttons")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }